import { useRouter } from 'next/router';
import { useCallback } from 'react';
import {
  buildOpenAppClickedParams,
  sendToFirebaseAnalytics,
} from '~/common/hooks/use-firebase-analytics';
import { useNotifications } from '~/common/hooks/use-notifications';
import { useSidebar } from '~/common/hooks/use-sidebar';
import { useWasAlreadyVipUser } from '~/common/hooks/use-was-already-vip-user';
import { createAppInstallUrl, deeplink } from '~/utils/url';

export const useLocalState = () => {
  const router = useRouter();
  const notifications = useNotifications(router.asPath);

  const { wasAlreadyVip } = useWasAlreadyVipUser();

  const sidebar = useSidebar(wasAlreadyVip);

  const handleOnClickInAppHeader = useCallback(() => {
    if (typeof window === 'undefined') return;

    const eventPage = location.pathname;
    const eventParentPage = location.pathname.replace(/\/[^/]*$/, '');

    sendToFirebaseAnalytics(
      'open_app_clicked',
      buildOpenAppClickedParams({
        page: eventPage,
        parentPage: eventParentPage,
        component: 'top_banner',
      })
    );

    window.location.href = createAppInstallUrl({
      deepLinkValue: deeplink(),
    });
  }, []);

  return {
    wasAlreadyVip,
    notifications,
    sidebar,
    handleOnClickInAppHeader,
  };
};
